<template>
  <div class="hotel-wrap">
      <hotel-where />
  </div>
</template>

<script>
import hotelWhere from '@/components/publicmap'
export default {
    name: "hotelInfo",
    components: {
        hotelWhere
    }
}
</script>

<style>

</style>